// import React, { useState, useEffect } from "react";
// import { Swiper, SwiperSlide } from 'swiper/react';
// import { Navigation } from 'swiper/modules';
// import 'swiper/css';
// import 'swiper/css/navigation';
// import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
// import { getWithoutTokenAPI } from "../../util/Api";
// import "./Team.css";
// import { useNavigate } from "react-router-dom";

// const Team = () => {
//   const [sellers, setSellers] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const navigate = useNavigate();
// const useWindowWidth = () => {
//   const [width, setWidth] = useState(window.innerWidth);

//   useEffect(() => {
//     const handleResize = () => setWidth(window.innerWidth);
//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   return width;
// };
// const width = useWindowWidth();

// let showArrows = false;

// if (width >= 1200 && sellers.length > 4) {
//   showArrows = true;
// } else if (width >= 992 && sellers.length > 3) {
//   showArrows = true;
// } else if (width >= 640 && sellers.length > 2) {
//   showArrows = true;
// } else if (width < 640 && sellers.length > 1) {
//   showArrows = true;
// }

//   useEffect(() => {
//     const fetchSellers = async () => {
//       try {
//         const response = await getWithoutTokenAPI('/seller/find-all');
//         if (response.statusCode === 200) {
//           setSellers(response.data.User || []);
//         } else {
//           setError("Failed to fetch sellers");
//         }
//       } catch (err) {
//         setError("Error loading sellers");
//         console.error("Error fetching sellers:", err);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchSellers();
//   }, []);

//   const handleSellerClick = (seller) => {
//     navigate(`/shop?seller_name=${seller.name}&seller_id=${seller._id}`, { 
//       state: { 
//         selectedSellerId: seller._id,
//         selectedSeller: seller.name 
//       }
//     });
//   };

//   if (loading) {
//     return <div className="loading-message">Loading sellers...</div>;
//   }

//   if (error) {
//     return <div className="error-message">{error}</div>;
//   }

//   return (
//     <div className="team-container">
//       <div className="container">
//           { sellers.length > 0 && (
//             <>
//     <h6
//   className="text-center ff-poppins fs-14 fw-500 fc-green category-title"
//   data-aos="fade-down"
//   data-aos-delay="100"
// >
//   SELLERS
// </h6>

// <h2
//   className=" ff-poppins fs-36 fw-600 category-title-2 mb-4"
//   data-aos="fade-up"
//   data-aos-delay="200"
// >
//   Our Sellers
// </h2>

         


// </>
//  )}

//         <div className="team-swiper-container mt-5">
    

//           { sellers.length > 0 && (
//   // <Swiper
//   //   modules={[Navigation]}
//   //   spaceBetween={30}
//   //   slidesPerView={4}
//   //   navigation={{
//   //     nextEl: '.team-next',
//   //     prevEl: '.team-prev',
//   //   }}
//   //   breakpoints={{
//   //     320: { slidesPerView: 1 },
//   //     640: { slidesPerView: 2 },
//   //     992: { slidesPerView: 3 },
//   //     1200: { slidesPerView: 4 }
//   //   }}
//   // >
//   <Swiper
//   modules={[Navigation]}
//   spaceBetween={30}
//   slidesPerView={4}
//   navigation={showArrows ? {
//     nextEl: '.team-next',
//     prevEl: '.team-prev',
//   } : false}
//   breakpoints={{
//     320: { slidesPerView: 1 },
//     640: { slidesPerView: 2 },
//     992: { slidesPerView: 3 },
//     1200: { slidesPerView: 4 }
//   }}
// >

//     {sellers.map((seller) => (
//       <SwiperSlide key={seller._id}>
//         <div className="team-card" onClick={() => handleSellerClick(seller)}>
//           <img 
//             src={seller.profile_image} 
//             alt={seller.name} 
//             className="team-img"
//             onError={(e) => {
//               e.target.onerror = null;
//             }}
//           />
//           <div className="team-info">
//             <h3>{seller.name}</h3>
//             <p>{seller.role}</p>
//           </div>
//         </div>
//       </SwiperSlide>
//     ))}
//   </Swiper>
// )}



//    {/* { sellers.length > 4 && (
//   <div className="team-navigation">
//     <button className="team-prev">
//       <FaChevronLeft className="arrow-icon" />
//     </button>
//     <button className="team-next">
//       <FaChevronRight className="arrow-icon" />
//     </button>
//   </div>
// )} */}

// {showArrows && (
//   <div className="team-navigation">
//     <button className="team-prev">
//       <FaChevronLeft className="arrow-icon" />
//     </button>
//     <button className="team-next">
//       <FaChevronRight className="arrow-icon" />
//     </button>
//   </div>
// )}


//         </div>
//       </div>
//     </div>
//   );
// };

// export default Team;

"use client"

import { useState, useEffect, useCallback } from "react"
import { Swiper, SwiperSlide } from "swiper/react"
import { Navigation } from "swiper/modules"
import "swiper/css"
import "swiper/css/navigation"
import { FaChevronLeft, FaChevronRight } from "react-icons/fa"
import { getWithoutTokenAPI } from "../../util/Api"
import "./Team.css"
import { useNavigate } from "react-router-dom"

const Team = () => {
  const [sellers, setSellers] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const navigate = useNavigate()

  const useWindowWidth = () => {
    const [width, setWidth] = useState(0)
    useEffect(() => {
      const handleResize = () => setWidth(window.innerWidth)
      setWidth(window.innerWidth) // Set initial width
      window.addEventListener("resize", handleResize)
      return () => window.removeEventListener("resize", handleResize)
    }, [])
    return width
  }

  const width = useWindowWidth()

  // FIX: Corrected dynamic showArrows logic based on screen width and sellers count
  let requiredSellersForArrows = 0 // Default: no arrows
  if (width >= 1200) {
    requiredSellersForArrows = 4 // Desktop: show arrows if > 4 sellers (i.e., 5 or more)
  } else if (width >= 992) {
    requiredSellersForArrows = 3 // Larger Tablet/Small Desktop: show arrows if > 3 sellers (i.e., 4 or more)
  } else if (width >= 640) {
    requiredSellersForArrows = 2 // Tablet: show arrows if > 2 sellers (i.e., 3 or more)
  } else if (width > 0 && width < 640) {
    requiredSellersForArrows = 1 // Mobile: show arrows if > 1 seller (i.e., 2 or more)
  }

  const showArrows = sellers.length > requiredSellersForArrows

  useEffect(() => {
    const fetchSellers = async () => {
      try {
        const response = await getWithoutTokenAPI("/seller/find-all")
        if (response.statusCode === 200) {
          setSellers(response.data.User || [])
        } else {
          setError("Failed to fetch sellers")
        }
      } catch (err) {
        setError("Error loading sellers")
        console.error("Error fetching sellers:", err)
      } finally {
        setLoading(false)
      }
    }
    fetchSellers()
  }, [])

  const handleSellerClick = useCallback(
    (seller) => {
      navigate(`/shop?seller_name=${seller.name}&seller_id=${seller._id}`, {
        state: {
          selectedSellerId: seller._id,
          selectedSeller: seller.name,
        },
      })
    },
    [navigate],
  )

  if (loading) {
    return <div className="loading-message">Loading sellers...</div>
  }
  if (error) {
    return <div className="error-message">{error}</div>
  }

  return (
    <div className="team-container">
      <div className="container">
        {sellers.length > 0 && (
          <>
            <h6
              className="text-center ff-poppins fs-14 fw-500 fc-green category-title"
              data-aos="fade-down"
              data-aos-delay="100"
            >
              SELLERS
            </h6>
            <h2 className="ff-poppins fs-36 fw-600 category-title-2 mb-4" data-aos="fade-up" data-aos-delay="200">
              Our Sellers
            </h2>
          </>
        )}
        <div className="team-swiper-container mt-5">
          {sellers.length > 0 && (
            <Swiper
              modules={[Navigation]}
              spaceBetween={30}
              slidesPerView={4} // This is the default for desktop, breakpoints handle others
              navigation={
                showArrows
                  ? {
                      nextEl: ".team-next",
                      prevEl: ".team-prev",
                    }
                  : false
              }
              breakpoints={{
                320: { slidesPerView: 1 },
                640: { slidesPerView: 2 },
                992: { slidesPerView: 3 },
                1200: { slidesPerView: 4 },
              }}
            >
              {sellers.map((seller) => (
                <SwiperSlide key={seller._id}>
                  <div className="team-card" onClick={() => handleSellerClick(seller)}>
                    <img
                      src={seller.profile_image || "/placeholder.svg"}
                      alt={seller.name}
                      className="team-img"
                      onError={(e) => {
                        e.target.onerror = null
                        e.target.src = "/placeholder.svg?height=200&width=200" // Fallback image
                      }}
                    />
                    <div className="team-info">
                      <h3>{seller.name}</h3>
                      <p>{seller.role}</p>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          )}
          {showArrows && (
            <div className="team-navigation">
              <button className="team-prev">
                <FaChevronLeft className="arrow-icon" />
              </button>
              <button className="team-next">
                <FaChevronRight className="arrow-icon" />
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default Team
